import React from 'react';
import ForgetPassword from '../ForgetPassword';
import Footer from '../Footer';

function ForgetPasswordPage() {
  return (
    <div>
      <ForgetPassword />
      <Footer />
    </div>
  );
}

export default ForgetPasswordPage;
